cb.define([], function() {
	var RM_rm_reservefundlist_VM_Extend = {

		doAction: function(name, viewmodel) {
			if(this[name]) {
				this[name](viewmodel);
			}
		},
		init: function(viewmodel) {
			viewmodel.addProperty('balance', new cb.models.SimpleModel());
			viewmodel.get("balance").setState("readOnly", true);
			this.getBalance(viewmodel);
			var self = this;
			viewmodel.on('refresh', function(args) {
				self.getBalance(viewmodel);
			});
		},
		getBalance: function (viewmodel) {
			debugger
			var proxy = cb.rest.DynamicProxy.create({
				ensure: {
					url: '/bill/getbalance',
					method: 'POST'
				}
			});
			var params = {
				billnum: "rm_reservefundlist"
			}
			proxy.ensure(params, function(err, result) {
				if(err) {
					cb.utils.alert(err.message, 'error');
					return;
				}
				if(result != null) {
					var balance = 0.00;
					if(parseFloat(result.balance).toString() != "NaN")
					{
						balance = parseFloat(result.balance).toFixed(2);
					}
					viewmodel.get("balance").setValue(balance);
				}
			});
		}
	}
	try {
		module.exports = RM_rm_reservefundlist_VM_Extend;
	} catch(error) {

	}
	return RM_rm_reservefundlist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_reservefundlist_VM.Extend.js